let company = 'snapwise';
const generateBase = () => {
  const url = window.location.host;
  const base = url.substring(0, url.indexOf('-'));
  return base;
};
const generateRootUrl = () => {
  const base = generateBase();
  if (!base) return `https://${company}-scm.truckxi.com/api/`
  if (base === 'local') return 'http://localhost:8001/';
  return `https://${base}-scm.truckxi.com/api/`
};
let ROOT_URL = generateRootUrl();
// let ROOT_URL = 'https://admin.apoodr.com/api/';
// let ROOT_URL = 'http://localhost:8001/';
// falcon: https://scm.realtoreasier.com/
// let ROOT_URL = 'https://scm.gvyummyus.com/api/';
// let ROOT_URL = 'https://erp.chinatown-supermarket.com/api/';
// let ROOT_URL = 'https://hfstage-erp.truckxi.com/api/';
let VERSION_NUM = '20018';

const companyCode = localStorage.getItem('companyCode');
let ROOT_API_URL = '';
if (companyCode === 'PS') {
  ROOT_API_URL = 'https://premiumstella-scm.truckxi.com/api/';
} else if (companyCode === 'LAC') { // isCalco
  ROOT_API_URL = 'https://calco-scm.truckxi.com/api/';
} else if (companyCode === 'CW') {
  ROOT_API_URL = 'https://chunwei-scm.truckxi.com/api/';
} else if (companyCode === 'CT') { // isEcity
  ROOT_API_URL = 'https://ct-scm.truckxi.com/api/';
} else if (companyCode === 'MM') { // isMyuMyu
  ROOT_API_URL = 'https://myumyu-scm.truckxi.com/api/';
} else if (companyCode === 'JML') { // isJML
  ROOT_API_URL = 'https://jml-scm.truckxi.com/api/';
} else if (companyCode === 'HMM') { // isHMM
  ROOT_API_URL = 'https://hmm-scm.truckxi.com/api/';
} else if (companyCode === 'DHC') { // isDHC
  ROOT_API_URL = 'https://dhc-scm.truckxi.com/api/';
} else if (companyCode === 'AFG') { // isAFG
  ROOT_API_URL = 'https://afg-scm.truckxi.com/api/';
} else if (companyCode === 'RVR') { // isRivera
  ROOT_API_URL = 'https://rivera-scm.truckxi.com/api/';
} else if (companyCode === 'YB') { // isYibao
  ROOT_API_URL = 'https://yipao-scm.truckxi.com/api/';
} else if (companyCode === 'LK') { // isLucky
  ROOT_API_URL = 'https://lucky-scm.truckxi.com/api/';
} else if (companyCode === 'WE') { // isWecom
  ROOT_API_URL = 'https://wecom-scm.truckxi.com/api/';
} else if (companyCode === 'KH') { // isKouhigh
  ROOT_API_URL = 'https://afg-scm.truckxi.com/api/';
} else if (companyCode === 'FV') { // isFung
  ROOT_API_URL = 'https://fung-scm.truckxi.com/api/';
} else if (companyCode === 'CO') { // isCO
  ROOT_API_URL = 'https://co-scm.truckxi.com/api/';
} else if (companyCode === 'MMD') { // isMMD
  ROOT_API_URL = 'https://mmdavis-scm.truckxi.com/api/';
} else if (companyCode === 'SY') { // isSY
  ROOT_API_URL = 'https://admin.apoodr.com/api/';
} else if (companyCode === 'GV') { // isGV
  ROOT_API_URL = 'https://gvyummy-scm.truckxi.com/api/';
} else if (companyCode === 'FN') { // isFN
  ROOT_API_URL = 'https://falcon-scm.truckxi.com/api/';
} else if (companyCode === 'PTS') { // isPTS
  ROOT_API_URL = 'https://phantoscope-scm.truckxi.com/api/';
} else if (companyCode === 'AFM') { // isAFM
  ROOT_API_URL = 'https://afm-scm.truckxi.com/api/';
} else if (companyCode === 'AN') { // isAN
  ROOT_API_URL = 'https://asian-scm.truckxi.com/api/';
} else if (companyCode === 'ABC') { // isABC
  ROOT_API_URL = 'https://abc-scm.truckxi.com/api/';
} else if (companyCode === 'TN') { // isTN
  ROOT_API_URL = 'https://tn-scm.truckxi.com/api/';
} else if (companyCode === 'PD') { // isPD
  ROOT_API_URL = 'https://uspride-scm.truckxi.com/api/';
} else if (companyCode === 'FC') { // isFC
  ROOT_API_URL = 'https://fit-scm.truckxi.com/api/';
} else if (companyCode === 'JTB') { // isJTB
  ROOT_API_URL = 'https://jtb-scm.truckxi.com/api/';
} else if (companyCode === 'IN') { // isIN
  ROOT_API_URL = 'https://inutra-scm.truckxi.com/api/';
} else if (companyCode === 'CNT') { // isCNT
  ROOT_API_URL = 'https://erp.chinatown-supermarket.com/api/';
} else if (companyCode === 'WIZ') { // isWIZ
  ROOT_API_URL = 'https://wiz-scm.truckxi.com/api/';
} else if (companyCode === 'DSQ') { // isDSQ
  ROOT_API_URL = 'https://dsq-scm.truckxi.com/api/';
} else if (companyCode === 'FJ') { // isFJ
  ROOT_API_URL = 'https://fj-scm.truckxi.com/api/';
} else if (companyCode === 'HF') { // isHF
  ROOT_API_URL = 'https://hfstage-erp.truckxi.com/api/';
} else if (companyCode === 'NBT') { // isNBT
  ROOT_API_URL = 'https://nbtstage-scm.truckxi.com/api/';
} else if (companyCode === 'LO') { // isLO
  ROOT_API_URL = 'https://lonni-scm.truckxi.com/api/';
} else if (companyCode === 'EG') { // isEG
  ROOT_API_URL = 'https://elegant-scm.truckxi.com/api/';
} else if (companyCode === 'CS') { // isCS
  ROOT_API_URL = 'https://coastsequoia-scm.truckxi.com/api/';
} else if (companyCode === 'MAG') { // isMAG
  ROOT_API_URL = 'https://magna-scm.truckxi.com/api/';
} else if (companyCode === 'TQ') { // isTQ
  ROOT_API_URL = 'https://topquality-scm.truckxi.com/api/';
} else if (companyCode === 'FACEX') {
  ROOT_API_URL = 'https://facex-scm.truckxi.com/api/';
} else if (companyCode === 'OCM') { // isOCM
  ROOT_API_URL = 'https://ocm-scm.truckxi.com/api/';
} else if (companyCode === 'ATL') { // isATL
  ROOT_API_URL = 'https://alton-scm.truckxi.com/api/';
} else if (companyCode === 'FBD') { // isFBD
  ROOT_API_URL = 'https://fbd-scm.truckxi.com/api/';
} else if (companyCode === 'ABCFF') { // isABCFF
  ROOT_API_URL = 'https://abcff-scm.truckxi.com/api/';
} else if (companyCode === 'SW') { // isSW
  ROOT_API_URL = 'https://snapwise-scm.truckxi.com/api/';
} else if (companyCode === 'EZ') { // isEZ
  ROOT_API_URL = 'https://ezone-scm.truckxi.com/api/';
} else if (companyCode === 'YI') { // isYI
  ROOT_API_URL = 'https://ying-scm.truckxi.com/api/';
} else if (companyCode === 'RS') { // isRS
  ROOT_API_URL = 'https://redstone-scm.truckxi.com/api/';
} else if (companyCode === 'ASAP') { // isASAP
  ROOT_API_URL = 'https://asap-scm.truckxi.com/api/';
} else if (companyCode === 'VIT') { // isVIT
  ROOT_API_URL = 'https://vitcell-scm.truckxi.com/api/';
} else if (companyCode === 'KDW') { // isKDW
  ROOT_API_URL = 'https://kdw-scm.truckxi.com/api/';
} else if (companyCode === 'NO') { // isNO
  ROOT_API_URL = 'https://no-scm.truckxi.com/api/';
} else if (companyCode === 'WUFS') { // isWUFS
  ROOT_API_URL = 'https://wufs-scm.truckxi.com/api/';
} else if (companyCode === 'KM') { // isKM
  ROOT_API_URL = 'https://kingmax-scm.truckxi.com/api/';
} else if (companyCode === 'GS') { // isGS
  ROOT_API_URL = 'https://grantstone-scm.truckxi.com/api/';
} else {
  ROOT_API_URL = ROOT_URL;
}

console.log('ROOT_API_URL', ROOT_API_URL);
let companyCodeTitle = companyCode ? companyCode + ' Truckxi-SCM' : 'Truckxi-SCM';
if (ROOT_URL === 'https://scm.gvyummyus.com/api/') {
  companyCodeTitle = companyCode + ' SCM';
}

const checkCompany = (companies = [], companyCode) => {
  return companies.indexOf(company) >= 0;
}

export const isRivera = checkCompany(['rivera', 'riverastage', 'rvrstage']);
export const isSY = checkCompany(['sunny', 'apoodr']);
export const isFV = checkCompany(['fung']);
export const isLO = checkCompany(['lonni']);
export const isElegant = checkCompany(['elegant']);
export const isSnapwise = checkCompany(['snapwise']);
export const isWUFS = checkCompany(['wufs']);
export const isEcity = checkCompany(['ct']);
export const isLucky88 = checkCompany(['lucky88']);
export const isUSPride = checkCompany(['uspride']);
export const isCNT = checkCompany(['cnt']);
export const isCalco = checkCompany(['calco']);
export const isJML = checkCompany(['jml']);

//export const isTN = checkCompany(['tn', 'tnstage']);
//export const isFBD = checkCompany(['fbd']);
/*
  These ROOT URLS were found on the url.jsx page.
  In case they're important later, I'll be leaving them here for safekeeping

  let ROOT_URL = "http://54.175.18.0/";
  let ROOT_URL = "http://oauth2.truckxi.com/";
  let ROOT_URL = "http://34.201.89.104/api/";
  let ROOT_URL = 'https://stage-scm.truckxi.com/api/'';
  let ROOT_URL = 'http://54.175.18.0/'';
  let ROOT_URL = 'http://192.168.0.13:8001/'';
*/

exports.VERSION_NUM = VERSION_NUM;
exports.ROOT_URL = ROOT_URL;
exports.ROOT_API_URL = ROOT_API_URL;
exports.companyCodeTitle = companyCodeTitle;



// WEBPACK FOOTER //
// ./master/jsx/actions/root_url.jsx